import React, { Component } from 'react'

const initialState = {
  drag: false,
  dragging: false
}

let dragCounter = 0

class Dropzone extends Component {
  constructor () {
    super()
    this.state = initialState
    this.handleDrag = this.handleDrag.bind(this)
    this.handleDragIn = this.handleDragIn.bind(this)
    this.handleDragOut = this.handleDragOut.bind(this)
    this.handleDrop = this.handleDrop.bind(this)
  }

  handleDrag (e) {
    e.preventDefault()
    e.stopPropagation()
  }

  handleDragIn (e) {
    e.preventDefault()
    e.stopPropagation()
    // this.setState({ dragging: true })
    dragCounter++
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true })
    }
  }

  handleDragOut (e) {
    e.preventDefault()
    e.stopPropagation()
    // this.setState({ dragging: false })
    dragCounter--
    if (dragCounter === 0) {
      this.setState({ drag: false })
    }
  }

  handleDrop (e) {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ drag: false })
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.props.handleDrop(e.dataTransfer.files)
      e.dataTransfer.clearData()
      dragCounter = 0
    }
  }

  componentDidMount () {
    window.addEventListener('dragenter', this.handleDragIn)
    window.addEventListener('dragleave', this.handleDragOut)
    window.addEventListener('dragover', this.handleDrag)
    window.addEventListener('drop', this.handleDrop)
  }

  componentWillUnmount () {
    window.removeEventListener('dragenter', this.handleDragIn)
    window.removeEventListener('dragleave', this.handleDragOut)
    window.removeEventListener('dragover', this.handleDrag)
    window.removeEventListener('drop', this.handleDrop)
  }

  render () {
    return (
      <div>
        {this.state.drag &&
          <div className="file-drop-target">
            <i className="fas fa-cloud-upload-alt"></i>
          </div>
        }
      </div>
    )
  }
}
export default Dropzone
